(function () {
  function resetProductModalSwiperHeight(modal) {
    if (!modal) return;

    modal.querySelectorAll(".swiper").forEach((swiperEl) => {
      const wrapper = swiperEl.querySelector(".swiper-wrapper");

      if (wrapper) {
        wrapper.style.height = "auto";
      }

      if (swiperEl.swiper) {
        swiperEl.swiper.update();
        swiperEl.swiper.updateSize();
        swiperEl.swiper.updateSlides();

        if (typeof swiperEl.swiper.updateAutoHeight === "function") {
          swiperEl.swiper.updateAutoHeight(0);
        }

        if (wrapper) {
          wrapper.style.height = "auto";
        }
      }
    });
  }

  function initProductModalSwiperHeightFix() {
    document
      .querySelectorAll("product-modal.product-media-modal")
      .forEach((modal) => {
        if (modal.dataset.productModalSwiperFix === "true") return;

        modal.dataset.productModalSwiperFix = "true";

        const observer = new MutationObserver(() => {
          if (!modal.hasAttribute("open")) return;

          requestAnimationFrame(() => {
            resetProductModalSwiperHeight(modal);

            setTimeout(() => {
              resetProductModalSwiperHeight(modal);
            }, 150);

            setTimeout(() => {
              resetProductModalSwiperHeight(modal);
            }, 400);
          });
        });

        observer.observe(modal, {
          attributes: true,
          attributeFilter: ["open", "class"],
        });
      });
  }

  function swiperInit() {
    if (typeof subSliderInit === "function") {
      subSliderInit(true);
    }

    if (typeof sliderInit === "function") {
      sliderInit(true);      
    }

    if (typeof popupSliderInit === "function") {
      popupSliderInit(true);
    }

    const mainProductSection = document.querySelector(".main-product-section");

    if (mainProductSection?.dataset?.mainProductDifferentGallery === "true") {
      window.__mainProductDifferentGallery = true;

      if (typeof subSliderInit === "function") {
        subSliderInit(true, ".js-media-mobile-list", ".js-media-mobile-sublist");
      }

      if (typeof sliderInit === "function") {
        sliderInit(true, ".js-media-mobile-list", ".js-media-mobile-sublist");
      }
    }

    initProductModalSwiperHeightFix();
  }

  function initSwiperOnce() {
    if (window.isSwiperInit) return;

    swiperInit();

    /*
      This file can be loaded from main-product.liquid and featured-product.liquid.
      This prevents duplicate Swiper initialization on normal page load.
    */
    window.isSwiperInit = true;
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initSwiperOnce);
  } else {
    initSwiperOnce();
  }

  document.addEventListener("shopify:section:load", function () {
    /*
      Shopify editor reloads section HTML, so we need to initialize the new markup.
      Do not block this with window.isSwiperInit.
    */
    swiperInit();
  });
})();


